module.exports = __webpack_public_path__ + "supplier/img/logo2x.a882a80f.png";